module.exports = __webpack_public_path__ + "img/trailClass.a389afe5.png";